import { useLanguageContext } from "../context/LanguageContext";

import RedirectButton from "./ui/RedirectButton"

export default function SendedComponent() {
  const { t } = useLanguageContext();

  return (
    <>
      <div className="w-16 h-16 rounded-full bg-main_accent/20 flex items-center justify-center text-main_accent text-3xl">
        ✓
      </div>

      <h2 className="text-2xl font-semibold text-white">
        {t("joinPage", "formState", "successTitle")}
      </h2>

      <p className="max-w-[32ch] text-gray-400 text-sm pb-6">
        {t("joinPage", "formState", "successSubtitle")}
      </p>

      <RedirectButton title={t("joinPage", "formState", "returnButton")} />
    </>
  );
}
